export const services = [
    {
        id: 1,
        bannerServices: require('../assets/services/service1.jpg'),
        defaultImage: require('../assets/icons/services1.png'),
        hoverImage: require('../assets/icons/services1_1.png'),
        title: 'Dịch vụ vệ sinh nội thất',
        benefit: 'vệ sinh nội thất',
        benefitImage: require('../assets/benafit/benafit.png'),
        benefitContent: [
            {
                benefitHead: 'Loại bỏ vết bẩn nhanh chóng',
                benefixDescription:
                    'Với những sản phẩm chăm sóc xe chuyên dụng, đội ngũ dọn vệ sinh nội thất xe hơi của chúng tôi đều xử lý được toàn bộ các vết bẩn từ thảm, ghế ngồi, lớp lót trần, cốp xe,… mang đến một bề mặt bóng nhẵn, sạch đẹp tinh tươm nhất.',
            },
            {
                benefitHead: 'Diệt khuẩn, nấm mốc gây hại',
                benefixDescription:
                    'Theo nghiên cứu, bên trong khoang nội thất ô tô chứa hơn 700 loại vi khuẩn khác nhau. Nếu bạn vô tình tiếp xúc với chúng sẽ ảnh hưởng đến sức khỏe. Vệ sinh nội thất ô tô thường xuyên sẽ hạn chế các loại vi khuẩn, nấm mốc gây hại và đảm bảo luồng không khí lưu thông trong sạch hơn.',
            },
            {
                benefitHead: 'Khử sạch mùi hôi khó chịu',
                benefixDescription:
                    'Mùi nước mắm, nước ngọt, mùi khói thuốc,… gây buồn nôn cho nhiều hành khách mỗi khi ngồi trong xe. Khử khuẩn bề mặt bằng dung dịch vệ sinh nội thất ô tô chuyên dụng giúp loại bỏ chất bẩn, mùi hôi cứng đầu. Kết hợp với máy khử mùi tiên tiến mang lại không gian nội thất sạch sẽ như mới.',
            },
            {
                benefitHead: 'Duy trì, phục hồi độ sáng bóng',
                benefixDescription:
                    'Mọi bề mặt chi tiết nhựa, cao su, vinyl,… đều được vệ sinh, khử mùi, phục hồi và bảo dưỡng nhằm khôi phục lại vẻ ngoài như mới. Trải nghiệm dịch vụ vệ sinh nội thất ô tô tại Vietnam Car Care giúp bạn tận hưởng không gian nội thất sang trọng, đẳng cấp, sạch không tì vết.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Kiểm tra tình trạng xe',
                stepDescription:
                    'Đánh giá tình trạng bám bẩn, bám mùi hôi trong khoang nội thất ô tô. Qua đó, ước lượng được thời gian hoàn thiện để khách hàng nắm bắt thông tin nhận xe nhanh.',
            },
            {
                stepHead: 'Bước 2: Chuẩn bị dụng cụ, sản phẩm',
                stepDescription:
                    'Kiểm tra và chuẩn bị kỹ lưỡng các dụng cụ, sản phẩm chuyên dụng nhằm tránh mất thời gian khi vệ sinh nội thất xe.',
            },
            {
                stepHead: 'Bước 3: Vệ sinh thảm trải sàn',
                stepDescription: 'Trước khi dọn sạch nội thất ô tô, các thảm trải sàn cần phải được làm sạch đầu tiên.',
            },
            {
                stepHead: 'Bước 4: Tháo ghế ô tô (tùy chọn gói)',
                stepDescription:
                    'Các kỹ thuật viên của Vietnam Car Care sẽ tháo ghế an toàn, đúng cách để tiến hành vệ sinh chuyên sâu toàn bộ khoang nội thất ô tô.',
            },
            {
                stepHead: 'Bước 5: Hút bụi, vệ sinh nội thất xe hơi cơ bản',
                stepDescription:
                    'Với máy hút bụi công suất cao cùng các đầu hút nhỏ chuyên dụng, phù hợp hút sạch cặn bẩn dù là ở khu vực lớn đến các khe kẽ nhỏ bên dưới ghế, giúp khoang nội thất sạch bụi, đất cát.',
            },
            {
                stepHead: 'Bước 6: Làm sạch khu vực taplo',
                stepDescription:
                    'Xịt dung dịch khử khuẩn trên bề mặt ở khu vực taplo như bảng điều khiển, đồng hồ, vô lăng, cần số, audio,… bằng dung dịch vệ sinh nội thất ô tô chuyên dụng kết hợp quét cùng bàn chải lông mềm, khăn microfiber mềm mịn để làm sạch sâu các bề mặt.',
            },
            {
                stepHead: 'Bước 7: Vệ sinh trần xe ô tô',
                stepDescription:
                    'Sau khi vệ sinh khu vực taplo, thực hiện vệ sinh trần xe bằng dung dịch tẩy rửa an toàn với chổi quét lông mềm. Một số trần xe bằng chất liệu vải nỉ rất nhạy cảm với dung dịch tẩy rửa, nếu không sử dụng đúng loại có thể để lại vết loang ố, làm xấu trần nỉ',
            },
            {
                stepHead: 'Bước 8: Vệ sinh dây đai, giặt ghế ô tô',
                stepDescription:
                    'Dùng máy hơi nước và không xịt trực tiếp dung dịch tẩy bẩn lên ghế và dây đai. Thấm dung dịch vào khăn Microfiber sau đó lau nhẹ các bề mặt. Kế đến, làm sạch dây đai an toàn một lần nữa bằng vòi xịt nước áp lực tiêu chuẩn.',
            },
            {
                stepHead: 'Bước 9: Vệ sinh khe kẽ ron cửa, bề mặt kính chắn gió',
                stepDescription:
                    'Ở bước này, chúng tôi sẽ tập trung cận thận vào các bề mặt kính, gương và cửa sổ ô tô. Chà sạch các vết cặn bẩn bằng chỗi quét lông mềm và khăn microfiber chuyên dụng cùng với hỗn hợp chất tẩy rửa kính không chưa Amoniac. Dung dịch lau kính hoàn toàn an toàn với xe đã dán phim cách nhiệt ô tô.',
            },
            {
                stepHead: 'Bước 10: Vệ sinh khe gió điều hòa, khử mùi diệt khuẩn',
                stepDescription:
                    'Sau khi mọi thứ bên trong khoang nội thất đã được làm sạch, đã đến lúc tiến hành xử lý không khí, hơi ẩm bên trong bằng máy diệt khuẩn khử mùi nội thất ô tô C-Air Frog giúp tiêu diệt nhiều vi khuẩn, nấm mốc ẩn nấp bên trong xe.',
            },
            {
                stepHead: 'Bước 11: Phủ dưỡng nội thất ô tô',
                stepDescription:
                    'Bước cuối cùng khi xử lý chất bẩn, mùi hôi là phủ dưỡng nội thất ô tô bằng sản phẩm Ceramic IGL Coatings chuyên dụng. Trả lại bề mặt sạch bóng, giúp da, nhựa, kính tránh bị bạc màu, nứt nẻ bởi các ánh nắng mặt trời',
            },
            {
                stepHead: 'Bước 12: Kiểm tra tổng thể trước khi bàn giao',
                stepDescription:
                    'Đánh giá và kiểm tra lại toàn bộ bề mặt bên trong khoang nội thất. Đảm bảo không còn bụi bẩn, đất cát, mùi hôi bám trong khoang xe',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Dịch vụ vệ sinh nội thất ô tô bao gồm những công đoạn gì?',
                description:
                    'Theo khuyến cáo, thời gian dọn vệ sinh toàn bộ nội thất xe hơi tại trung tâm chăm sóc xe từ 2-3 tháng/lần. Nếu tình trạng xe bám bẩn, nhiều nấm mốc hoặc vô tình để các chất bẩn thấm bên trong, thời gian vệ sinh nội thất sẽ đến nhanh hơn. Ngoài ra, bạn có thể tự vệ sinh nội thất ô tô tại nhà sau mỗi lần sử dụng xe. Duy trì bề mặt sạch sẽ trước khi thực hiện vệ sinh nội thất xe hơi toàn diện là cách hữu hiệu nhất.',
            },
            {
                id: 2,
                text: 'Xe mới lấy có mùi nhựa mới nên vệ sinh nội thất ô tô không?',
                description:
                    'Dù chiếc xe của bạn có mùi hay không, bạn cũng nên lập ra kế hoạch chăm sóc và vệ sinh nội thất thường xuyên. Điều này giúp không gian bên trong xe luôn trong tình trạng sạch sẽ, bảo vệ sức khỏe, tăng độ bền chi tiết.',
            },
            {
                id: 3,
                text: 'Cần lưu ý đến vị trí nào khi vệ sinh nội thất ô tô?',
                description:
                    'Có rất nhiều vị trí cần lưu ý khi vệ sinh nội thất ô tô, dù lại tại nhà hay tại trung tâm chăm sóc xe. Một số vị trí cần lưu ý bao gồm nấm mốc bên dưới ghế ngồi, khe gió điều hòa, ron cửa sổ, dây đai, hộc đựng đồ, vải lót đựng đồ sau ghế, trần nỉ, thảm lót cốp,…',
            },
            {
                id: 4,
                text: 'Dọn vệ sinh nội thất xe hơi giá bao nhiêu?',
                description:
                    'Tùy vào từng trung tâm chăm sóc xe sẽ có mức giá dọn vệ sinh nội thất xe hơi được quy định khác nhau. Chi phí thực hiện còn phụ thuộc vào nhiều yếu tố từ chất lượng dịch vụ, mặt bằng, quy trình thực hiện, gói dịch vụ, tình trạng cần vệ sinh,… Bạn có thể tham khảo giá vệ sinh nội thất ô tô chung tại Vietnam Car Care, chi phí dao động từ 1.000.000 VNĐ – 2.000.000 VNĐ/lần. Tại đây, chúng tôi được khách hàng đánh giá cao về chất lượng dịch vụ bởi không sử dụng sản phẩm chứa hóa chất độc hại, kỹ thuật viên dày dặn kinh nghiệm, thao tác vệ sinh chi tiết, kỹ lưỡng',
            },
        ],
    },
    {
        id: 2,
        bannerServices: require('../assets/services/service2.jpg'),
        defaultImage: require('../assets/icons/services2.png'),
        hoverImage: require('../assets/icons/services2_2.png'),
        title: 'Dịch vụ đánh bóng xe',
        benefit: 'đánh bóng xe',
        benefitImage: require('../assets/benafit/benafit2.png'),
        benefitContent: [
            {
                benefitHead: 'Tăng độ sáng bóng, thêm lớp bảo vệ',
                benefixDescription:
                    'Bằng tác động của máy đánh bóng và xi đánh bóng, bề mặt sơn xe được tăng cường độ sáng bóng hơn ban đầu và thêm một lớp phủ bảo vệ bề mặt cơ bản.',
            },
            {
                benefitHead: 'Loại bỏ hoàn toàn khiếm khuyết sơn xe',
                benefixDescription:
                    'Ngoài các vết trầy xước, các khiếm khuyết sơn khác thường xuất hiện trên bề mặt như vết xoáy mạng nhện, đốm nước ăn mòn lâu ngày, vết sơn chảy, sơn vỏ cam, mắt cá, bụi sơn,... đều được loại bỏ hoàn toàn, tái tạo lại một bề mặt phẳng mịn như ban đầu.',
            },
            {
                benefitHead: 'Tạo bề mặt thích hợp để phủ Ceramic, dán PPF ô tô',
                benefixDescription:
                    'Trước khi phủ Ceramic hoặc dán PPF ô tô, bề mặt sơn xe đều phải được vệ sinh, loại bỏ sạch sẽ các vết cặn bẩn bám. Hiệu chỉnh sơn là quá trình bắt buộc phải thực hiện trước khi phủ các lớp bảo vệ sơn. Nếu không, bề mặt sau khi thi công sẽ không đạt tính thẩm mỹ.',
            },
            {
                benefitHead: 'Bảo vệ lớp sơn',
                benefixDescription:
                    'Đánh bóng tạo một lớp bảo vệ chống lại tác động của thời tiết, ánh nắng mặt trời, và các tác nhân gây hại khác, giúp lớp sơn bền màu hơn theo thời gian.',
            },
            {
                benefitHead: 'Giá trị thẩm mỹ và tăng giá trị bán lại',
                benefixDescription:
                    'Một chiếc xe có bề mặt sáng bóng và sạch sẽ thường có giá trị bán lại cao hơn vì tạo được ấn tượng tốt cho người mua.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Rửa xe và làm sạch bề mặt sơn',
                stepDescription:
                    'Kỹ thuật viên thực hiện rửa xe và làm sạch toàn bộ bề mặt sơn giúp các khuyết điểm sơn xuất hiện rõ ràng hơn. Chúng tôi sử dụng nước rửa xe chuyên dụng, có độ PH trung tính, các vết bẩn tại mọi ngóc ngách đều được loại bỏ hoàn toàn.',
            },
            {
                stepHead: 'Bước 2: Kiểm tra tình trạng sơn',
                stepDescription:
                    'Kỹ thuật viên sẽ kiểm tra, đánh giá các khiếm khuyết trên bề mặt sơn và đưa ra phương án hiệu chỉnh sơn phù hợp. Tiến hành đánh dấu lại các vị trí cần xử lý và dán lớp bảo vệ ở những khu vực không hiệu chỉnh, để tránh làm hỏng lớp sơn.',
            },
            {
                stepHead: 'Bước 3: Đánh bóng làm phẳng bề mặt sơn xe',
                stepDescription:
                    'Dựa vào độ dày mỏng khác nhau của sơn cũng như tình trạng khiếm khuyết sơn, kỹ thuật viên sẽ sử dụng kết hợp máy đánh bóng và xi đánh bóng xe ô tô để làm mịn và phẳng các vết xước, vết xoáy,…',
            },
            {
                stepHead: 'Bước 4: Hoàn thiện bề mặt',
                stepDescription:
                    'Để lớp sơn bề mặt sau khi loại bỏ các khiếm khuyết đạt được độ bóng hoàn hảo, có chiều sâu, láng mịn, cần được đánh bóng hoàn thiện với máy đánh bóng lệch tâm kết hợp pad đánh bóng hoàn thiện.',
            },
            {
                stepHead: 'Bước 5: Vệ sinh sạch sẽ',
                stepDescription:
                    'Xe sẽ được vệ sinh một lần nữa để đảm bảo không còn bất kỳ cặn xi đánh bóng dư thừa nào đọng lại. Đặc biệt, các vị trí như kẽ cửa xe, logo hay tại các khe hở luôn được kiểm tra và làm sạch tỉ mỉ.',
            },
            {
                stepHead: 'Bước 6:Phủ lớp bảo vệ sơn',
                stepDescription:
                    'Tùy vào nhu cầu của khách hàng, chúng tôi sẽ sử dụng các biện pháp bảo vệ sơn tối ưu nhất như phủ ceramic hoặc dán PPF. Lớp bảo vệ này giúp bề mặt sơn bền đẹp, giảm thiểu tối đa các bụi bẩn, trầy xước, vết ố,… tăng độ bền cho các chi tiết khác.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Vì sao nên đánh bóng sơn xe ô tô trước khi dán phim PPF và phủ Ceramic ô tô?',
                description:
                    'Về kỹ thuật, đánh bóng sơn xe ô tô và hiệu chỉnh sơn là bước để chuẩn bị bề mặt sơn xe được trơn mịn và lấy lại độ sáng bóng ban đầu. Tùy vào nhu cầu của khách hàng, để lớp sơn nguyên bản không xuất hiện khiếm khyết trên bề mặt sơn xe, chống bám bụi và các tác nhân gây hại khác, khách hàng nên lựa chọn thêm 1 trong 2 phương pháp bảo vệ phủ ceramic hoặc dán phim PPF.',
            },
            {
                id: 2,
                text: 'Xe mới có cần hiệu chỉnh sơn xe lại không?',
                description:
                    'Trên thực tế, nhiều bề mặt sơn của xe mới cũng không được hoàn hảo, hoặc trong quá trình vận chuyển từ nhà máy cho tới showroom, hoặc xe khách hàng bị trầy xước nhẹ trong khi sử dụng. Vì thế hiệu chỉnh sơn cũng sẽ được thực hiện trên xe mới trước khi dán phim PPF (có độ bền lên đến 5-10 năm) hoặc phủ ceramic (có độ bền khoảng 3-5 năm) cho xe ô tô.',
            },
            {
                id: 3,
                text: 'Có nên đánh bóng và hiệu chỉnh sơn xe ô tô trước khi dán PPF hay phủ Ceramic không?',
                description:
                    'Đánh bóng xe ô tô thực chất là một giai đoạn nằm trong quy trình hiệu chỉnh sơn và là bước xử lý giúp lớp sơn xe được sáng hơn sau khi đã loại bỏ các vết trầy xước. Để lớp phim PPF hoặc lớp Ceramic được bám dính hoàn hảo trên bề mặt thì lớp sơn phải hông tì vết khi hoàn thiện. Do đó, đánh bóng và hiệu chỉnh sơn xe hơi là điều cần thiết, không thể bỏ qua.',
            },
            {
                id: 4,
                text: 'Quá trình hiệu chỉnh sơn xe ô tô mất bao lâu?',
                description:
                    'Tùy thuộc vào tình trạng xe, thời gian hiệu chỉnh sơn trung bình khoảng từ 5-7 tiếng thực hiện. Bên cạnh đó, nếu khách hàng thi công thêm dịch vụ dán phim PPF hoặc phủ ceramic thì thời gian có thể mất 2-3 ngày để thực hiện.',
            },
            {
                id: 5,
                text: 'Bảng giá dịch vụ đánh bóng ô tô và Hiệu chỉnh sơn xe bao nhiêu?',
                description:
                    'Hiện nay trên thị trường có rất nhiều mức giá dịch vụ đánh bóng và hiệu chỉnh sơn xe. Kỹ thuật, chất lượng cũng như quy trình đánh bóng hiệu chỉnh sơn xe ô tô ở mỗi nơi sẽ khác nhau nên chi phí đánh bóng cũng sẽ khác nhau. Bên cạnh đó, giá của dịch vụ đánh bóng và hiệu chỉnh sơn xe ô tô cũng tùy thuộc vào phân khúc xe.Theo khảo sát tại TP HCM, bảng giá dịch vụ hiệu chỉnh sơn xe hơi tiêu chuẩn dao động từ 1.500.000 – 3.000.000 VNĐ.',
            },
        ],
    },
    {
        id: 3,
        bannerServices: require('../assets/services/service3.jpg'),
        defaultImage: require('../assets/icons/services3.png'),
        hoverImage: require('../assets/icons/services3_3.png'),
        title: 'Dịch vụ dán PPF ô tô',
        benefit: 'dán PPF',
        benefitImage: require('../assets/benafit/benafit3.png'),
        benefitContent: [
            {
                benefitHead: 'Chống trầy xước, bảo vệ lớp sơn',
                benefixDescription:
                    'Lớp màng phim PPF dày 7,5 mil mang đến khả năng chống trầy xước hoàn hảo. Không giống như PPF PVC hay TPH, phim bảo vệ sơn TPU của chúng tôi không làm ảnh hưởng đến lớp sơn xe bên dưới.',
            },
            {
                benefitHead: 'Chịu nhiệt cao',
                benefixDescription:
                    'Công nghệ phim PPF ô tô của APEAX có thể chịu được nhiệt độ cao, không bị ố vàng nhanh theo thời gian như những loại phim PPF trôi nổi khác trên thị trường. Với thời gian bảo hành 10 năm, bạn sẽ an tâm khi dán PPF ô tô tại Vietnam Car Care.',
            },
            {
                benefitHead: 'Tự phục hồi vết xước',
                benefixDescription:
                    'Trong số rất nhiều loại phim bảo vệ sơn được quảng cáo với khả năng tự phục hồi nhanh chóng, dòng phim APEAX PPF đã khẳng định được chất lượng TOP đầu hiện nay. Công nghệ vật liệu TPU tiên tiến nhất, có thể tự phục hồi nhanh các vết trầy xước.',
            },
            {
                benefitHead: 'Dễ dàng vệ sinh',
                benefixDescription:
                    'Tương tự như phủ Ceramic ô tô, dán PPF xe hơi cũng giúp chủ xe dễ dàng vệ sinh bởi đặc tính chống bám nước của lớp màng phim. Nhờ đó, vẻ ngoài xe sẽ luôn mới, tránh bám bẩn, hóa chất gây hại theo thời gian.',
            },
            {
                benefitHead: 'Tăng tính thẩm mỹ',
                benefixDescription:
                    'Với dịch vụ dán phim PPF cao cấp tại Vietnam Car Care, vẻ ngoài xe được nâng tầm đáng kể bằng 3 gói tùy chọn PPF có độ bóng sáng vừa phải, bóng mờ hoặc kết hợp với lớp phủ Ceramic. Màng phim mỏng, trong suốt, rất khó phát hiện bằng mắt thường.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Vệ sinh, đánh giá tình trạng bề mặt sơn',
                stepDescription:
                    'Trước tiên, kỹ thuật viên sẽ khử khuẩn bề mặt, rửa sạch xe đúng cách bắt đầu đánh giá sơ bộ những khiếm khuyết lỗi sơn trên bề mặt.',
            },
            {
                stepHead: 'Bước 2: Chuẩn bị kỹ bề mặt dán PPF',
                stepDescription:
                    'Trước khi dán phim PPF, bề mặt sơn xe cần phải được loại bỏ những khuyết điểm sơn hiện có. Đánh bóng và hiệu chỉnh sơn các bước giúp mang lại bề mặt sơn láng mịn, sẵn sàng để dán PPF.',
            },
            {
                stepHead: 'Bước 3: Cắt phim PPF ô tô thành từng phần riêng biệt',
                stepDescription:
                    'Tùy theo gói PPF mà khách hàng lựa chọn, kỹ thuật viên sẽ cắt theo kích thước của từng vị trí cần dán như đèn pha, gương chiếu hậu, thân xe, nắp capo, cản xe,…',
            },
            {
                stepHead: 'Bước 4: Dán màng phim PPF lên bề mặt',
                stepDescription:
                    'Tiến hành dán PPF ô tô theo đúng kỹ thuật chuẩn Detailing giúp kỹ thuật viên có thể dễ dàng điều chỉnh màng phim vào đúng vị trí. Bao gồm một loạt các thao tác phức tạp như phun dung dịch bôi trơn, gạt dung dịch và di chuyển màng phim PPF,…',
            },
            {
                stepHead: 'Bước 5: Kiểm tra lại bề mặt sau khi dán PPF ô tô',
                stepDescription:
                    'Kiểm tra lần cuối bề mặt sau khi dán PPF, trước khi bàn giao xe cho khách hàng. Đảm bảo bề mặt phim không bị bong bóng, nổi bọt khí, có nếp gấp phim',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Dán PPF ô tô tại Vietnam Car Care mất bao lâu?',
                description:
                    'Thời gian dán PPF ô tô tại trung tâm chăm sóc xe Vietnam Car Care khoảng 2 ngày cho toàn bộ xe. Phim PPF phải được cắt dán đúng kỹ thuật, vệ sinh, hiệu chỉnh bề mặt kỹ lưỡng trước khi thực hiện. Nếu xe của bạn xuất hiện nhiều vết xước xoáy, vết trầy, ăn mòn,… thời gian dán PPF xe hơi sẽ lâu hơn đôi chút nhưng không quá 3 ngày.',
            },
            {
                id: 2,
                text: 'Xe mới lấy có mùi nhựa mới nên vệ sinh nội thất ô tô không?',
                description:
                    'Dù chiếc xe của bạn có mùi hay không, bạn cũng nên lập ra kế hoạch chăm sóc và vệ sinh nội thất thường xuyên. Điều này giúp không gian bên trong xe luôn trong tình trạng sạch sẽ, bảo vệ sức khỏe, tăng độ bền chi tiết.',
            },
            {
                id: 3,
                text: 'Cần lưu ý đến vị trí nào khi vệ sinh nội thất ô tô?',
                description:
                    'Có rất nhiều vị trí cần lưu ý khi vệ sinh nội thất ô tô, dù lại tại nhà hay tại trung tâm chăm sóc xe. Một số vị trí cần lưu ý bao gồm nấm mốc bên dưới ghế ngồi, khe gió điều hòa, ron cửa sổ, dây đai, hộc đựng đồ, vải lót đựng đồ sau ghế, trần nỉ, thảm lót cốp,…',
            },
            {
                id: 4,
                text: 'Dọn vệ sinh nội thất xe hơi giá bao nhiêu?',
                description:
                    'Tùy vào từng trung tâm chăm sóc xe sẽ có mức giá dọn vệ sinh nội thất xe hơi được quy định khác nhau. Chi phí thực hiện còn phụ thuộc vào nhiều yếu tố từ chất lượng dịch vụ, mặt bằng, quy trình thực hiện, gói dịch vụ, tình trạng cần vệ sinh,… Bạn có thể tham khảo giá vệ sinh nội thất ô tô chung tại Vietnam Car Care, chi phí dao động từ 1.000.000 VNĐ – 2.000.000 VNĐ/lần. Tại đây, chúng tôi được khách hàng đánh giá cao về chất lượng dịch vụ bởi không sử dụng sản phẩm chứa hóa chất độc hại, kỹ thuật viên dày dặn kinh nghiệm, thao tác vệ sinh chi tiết, kỹ lưỡng',
            },
        ],
    },

    {
        id: 4,
        bannerServices: require('../assets/services/service4.jpg'),
        defaultImage: require('../assets/icons/services4.png'),
        hoverImage: require('../assets/icons/services4_4.png'),
        title: 'Dịch vụ phủ ceramic',
        benefit: 'phủ ceramic',
        benefitImage: require('../assets/benafit/benafit4.png'),
        benefitContent: [
            {
                benefitHead: 'Chịu nhiệt, chống tia UV có hại',
                benefixDescription:
                    'Tiếp xúc thường xuyên với tia cực tím gây hại sẽ làm ố vàng màu sơn. Phủ Ceramic ô tô giúp lớp sơn không bị phai màu theo thời gian. Với bản chất là gốm, lớp phủ Ceramic có khả năng chịu nhiệt cao lên đến 1000 độ C làm giảm khả năng tác động của ánh sáng mặt trời.',
            },
            {
                benefitHead: 'Kháng bụi bẩn, hóa chất độc hại',
                benefixDescription:
                    'Công nghệ phủ Ceramic cao cấp từ thương hiệu IGL Coatings giúp kháng nhiều hóa chất độc hại, chứa axit, chất tẩy rửa, phân chim, côn trùng,… bám vào lớp sơn xe gây ăn mòn.',
            },
            {
                benefitHead: 'Tạo độ bóng hoàn hảo',
                benefixDescription:
                    'Lợi ích dễ thấy nhất sau khi phủ Ceramic xe hơi là giúp bề mặt sơn xe có độ bóng sâu hoàn hảo, tạo vẻ ngoài bóng bẩy, sang trọng, chống bám bẩn.',
            },
            {
                benefitHead: 'Hạn chế trầy xước xoáy',
                benefixDescription:
                    'Không giống như phủ sáp hoặc sealant, lớp phủ Ceramic có khả năng hạn chế xước xoáy một phần do quá trình rửa xe ô tô không đúng cách gây ra hoặc những nguyên nhân khách quan khác.',
            },
            {
                benefitHead: 'Duy trì tuổi thọ lớp sơn xe',
                benefixDescription:
                    'Dịch vụ phủ Ceramic chất lượng cao sẽ giúp bảo vệ bề mặt sơn bên dưới qua nhiều năm, duy trì màu sơn nguyên bản không bị ố vàng, tránh xước xoáy, ăn mòn theo thời gian.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Sử dụng nước để rửa xe',
                stepDescription:
                    'Sử dụng paste xoá để đánh nhằm xoá các vết xước trên bề mặt. Nhằm xoá các vết xước lớn nhưng không ăn vào thân xe.',
            },
            {
                stepHead: 'Bước 2: Dùng paste xoá',
                stepDescription:
                    'Kỹ thuật viên sẽ kiểm tra, đánh giá các khiếm khuyết trên bề mặt sơn và đưa ra phương án hiệu chỉnh sơn phù hợp. Tiến hành đánh dấu lại các vị trí cần xử lý và dán lớp bảo vệ ở những khu vực không hiệu chỉnh, để tránh làm hỏng lớp sơn.',
            },
            {
                stepHead: 'Bước 3: Dùng paste bóng',
                stepDescription:
                    'Dùng paste bóng để tạo được độ bóng trên bề mặt sơn xe dùng paste bóng đánh lần thứ 2. Giúp mang lại độ bóng hoàn hảo nhất cho bề mặt sơn trước khi phủ ceramic ô sau khi đánh paste lần 1.',
            },
            {
                stepHead: 'Bước 4: Rửa xe vệ sinh',
                stepDescription:
                    'Rửa lại xe và vệ sinh chi tiết giúp vệ sinh thật kỹ những bụi bẩn còn sót lại trên bề mặt sơn trước khi tiến hành phủ ceramic.',
            },
            {
                stepHead: 'Bước 5: Phủ ceramic pro lên bề mặt sơn xe',
                stepDescription:
                    'Đây là một bước khá quan trọng, đòi hỏi người nhân viên phải có tay nghiề cao giúp phủ caremic thật đều trên bề mặt sơn xe. Đợi khoảng 30 phút để ceramic khô ráo.',
            },
            {
                stepHead: 'Bước 6:Làm khô lớp ceramic đã phủ',
                stepDescription:
                    'Sử dụng đèn sấy sơn hồng ngoại để làm khô lớp ceramic đã phủ, đây là bước rất quan trọng cần nắm rõ kỹ thuật để giúp gốm ceramic bám lâu, đảm bảo tuổi thọ.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Những điều cần tránh sau khi phủ Ceramic ô tô?',
                description:
                    'Trong vòng 24 - 48 giờ đầu tiên sau khi phủ ceramic, bạn không nên để xe tiếp xúc với nước như rửa xe hoặc di chuyển dưới mưa. Để hạn chế rủi ro trên, Vietnam Car Care sẽ dùng thêm sản phẩm chuyên dụng tạo một lớp bảo vệ tạm thời trong vòng 7 ngày. Sau đó, bạn có thể an tâm sử dụng xe mà không lo ảnh hưởng tới lớp phủ ceramic.',
            },
            {
                id: 2,
                text: 'Phủ Ceramic bao nhiêu lớp là tốt nhất? Nhiều lớp Ceramic có tốt không?',
                description:
                    'Lớp phủ Ceramic tối thiểu trên ô tô ít nhất là 2 lớp. Theo tiêu chuẩn hiện nay, số lượng lớp phủ Ceramic dừng lại ở 3-5 lớp. Quá nhiều lớp Ceramic không những không tạo ra sự liên kết trên bề mặt mà còn khiến bề mặt sơn bên dưới không ổn định, dễ bị rửa trôi nhanh..',
            },
            {
                id: 3,
                text: 'Độ bền lớp phủ Ceramic ô tô bao lâu?',
                description:
                    'Độ bền của lớp phủ ceramic phụ thuộc vào nhiều yếu tố như: điều kiện thời tiết, tay nghề thợ thi công, chất lượng lớp phủ, chế độ chăm sóc xe,… Thông thường, độ bền lớp phủ ceramic sẽ duy trì trong khoảng từ 2-5 năm, tùy thuộc vào dòng sản phẩm cơ bản hay cao cấp.',
            },
            {
                id: 4,
                text: 'Tại sao nên bảo dưỡng Ceramic ô tô định kỳ? Bao lâu bảo dưỡng lớp phủ Ceramic 1 lần?',
                description:
                    'Lớp ceramic trên ô tô cần phải được bảo dưỡng sau 3-6 tháng/lần thông qua việc sơn phủ thêm một lớp bảo vệ bề mặt từ nơi thực hiện dịch vụ.',
            },
        ],
    },
    {
        id: 5,
        bannerServices: require('../assets/services/service5.jpg'),
        defaultImage: require('../assets/icons/services5.png'),
        hoverImage: require('../assets/icons/services5_5.png'),
        title: 'Dịch vụ dán phim cách nhiệt APEAX',
        benefit: 'dán phim cách nhiệt APEAX',
        benefitImage: require('../assets/benafit/benafit5.png'),
        benefitContent: [
            {
                benefitHead: 'Chống nóng vượt trội',
                benefixDescription:
                    'Với cấu tạo gồm hàng triệu hạt gốm sứ siêu nhỏ, dòng phim cách nhiệt của APEAX có khả năng phản xạ hấp thụ tia hồng ngoại hiệu quả. Qua đó, nhiệt độ nóng bức bên trong xe được giảm đáng kể.',
            },
            {
                benefitHead: 'Đa lớp Nano Ceramic',
                benefixDescription:
                    'Công nghệ ép lớp màng phim áp lực cao thành nhiều lớp nano Ceramic siêu mỏng, siêu mịn giúp tăng hiệu năng của phim cách nhiệt APEAX một cách đáng kể.',
            },
            {
                benefitHead: 'Bảo vệ nội thất xe',
                benefixDescription:
                    'Nhờ đa lớp Nano Ceramic, khả năng cách nhiệt được nâng cao đáng kể. Giảm lượng nhiệt truyền từ mặt trời vào bên trong xe, bảo vệ nội thất tránh phai màu, lưu hóa cao su, nhựa nhám,…',
            },
            {
                benefitHead: 'Loại bỏ 99% tia UV',
                benefixDescription:
                    'Ngăn cản 99%+ tia UV cực tím (tia UVA, UVB, UVC) gây ung thư da và các vấn đề sức khỏe khác cũng như làm hỏng nội thất xe.',
            },
            {
                benefitHead: 'Duy trì màu phim ổn định',
                benefixDescription:
                    'Quá trình sản xuất đúng cách chỉ sử dụng vật liệu nền cao cấp để tạo ra lớp màu phim trong suốt, ít bị ố vàng hơn so với các sản phẩm cùng phân khúc và hạn chế cong vênh màng phim.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1:  Vệ sinh toàn bộ xe, bao gồm tẩy ố kính cửa sổ',
                stepDescription:
                    'Trước khi tiến hành dán phim cách nhiệt kính lái cửa sổ ô tô, bắt buộc phải rửa xe sạch sẽ. Tẩy ố kính (nếu xe cũ). Đưa xe vào phòng dán phim cách nhiệt tiêu chuẩn. ',
            },
            {
                stepHead: 'Bước 2: Lột bỏ phim cách nhiệt cũ (nếu có)',
                stepDescription:
                    'Nếu xe có dán phim cách nhiệt cũ, tiến hành lột bỏ ngay lớp màng cũ ố vàng, bong tróc bằng dụng cụ và dung dịch chuyên dụng. Cam kết không gây bể, trầy xước kính khi gỡ bỏ.',
            },
            {
                stepHead: 'Bước 3: Chuẩn bị và cắt phom phim cách nhiệt lên xe',
                stepDescription:
                    'Chuẩn bị sản phẩm và tiến hành cắt sẵn phom đối với các cửa sổ, kính lái, kính hậu tương ứng.',
            },
            {
                stepHead: 'Bước 4: Đặt màng phim đã chuẩn bị vào bề mặt kính',
                stepDescription:
                    'Lắp đặt màng phim vào bề mặt cần dán, lưu ý khi dán cần đảm bảo điều kiện ánh sáng đủ. Phim được cái dư 1 vài cm để vừa với cửa sổ sau khi cắt, tránh trầy kính.',
            },
            {
                stepHead: 'Bước 5: Tiến hành dán, gạt nước và cố định phim',
                stepDescription:
                    'Tiến hành dán phim cách nhiệt APEAX bằng thao tác xịt dung dịch, ép chặt màng phim bằng miếng gạt bọt nước, gạt bọt khí. Làm đến đâu gạt đến đó.',
            },
            {
                stepHead: 'Bước 6:Kiểm tra chất lượng sau khi dán phim cách nhiệt APEAX',
                stepDescription:
                    'Kiếm tra màng phim sau khi dán: Không bong tróc, không nổi bọt khí, dán thẩm mỹ phim, không cắt thừa hoặc thiếu màng phim, không có vết trầy trên kính,…',
            },
            {
                stepHead: 'Bước 7: Hướng dẫn chủ xe chăm sóc kính sau khi dán',
                stepDescription:
                    'Bàn giao xe hướng dẫn khách hàng cách chăm sóc kính cửa sổ xe sau khi dán phim cách nhiệt. Hạn chế nâng hạ kính sau khi dán.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Thời gian dán phim cách nhiệt Apeax bao lâu?',
                description:
                    'Thời gian dán phim cách nhiệt Apeax phụ thuộc vào nhiều yếu tố: Kích thước xe, tình trạng xe, số lượng kính cửa sổ cần dán, độ phức tạp của kính, tay nghề thợ dán phim cách nhiệt,… Tại Vietnam Car Care, thời gian dán phim cách nhiệt cho xe ô tô 4 chỗ khoảng 2-4 tiếng theo quy trình chuẩn Mỹ. Nếu tình trạng xe xấu hơn (đã dán phim cách nhiệt cũ), thời gian dán sẽ tăng lên do kỹ thuật viên phải mất thời gian loại bỏ các mảng phim cách nhiệt hư hỏng.',
            },
            {
                id: 2,
                text: 'Phim cách nhiệt Apeax có bị ố vàng không?',
                description:
                    'Bất kỳ loại phim cách nhiệt nào cũng gặp phải tình trạng ố vàng màng phim sau nhiều năm sử dụng. Với dòng phim cách nhiệt Apeax Nano Ceramic PRO, tình trạng ố vàng phim ở mức 5% đến 15% sau 5 năm.',
            },
            {
                id: 3,
                text: 'Cần lưu ý đến vị trí nào khi vệ sinh nội thất ô tô?',
                description:
                    'Có rất nhiều vị trí cần lưu ý khi vệ sinh nội thất ô tô, dù lại tại nhà hay tại trung tâm chăm sóc xe. Một số vị trí cần lưu ý bao gồm nấm mốc bên dưới ghế ngồi, khe gió điều hòa, ron cửa sổ, dây đai, hộc đựng đồ, vải lót đựng đồ sau ghế, trần nỉ, thảm lót cốp,…',
            },
            {
                id: 4,
                text: 'Nên dán phim cách nhiệt Apeax hay 3M?',
                description: `Cả hai thương hiệu phim cách nhiệt ô tô Apeax và 3M đều xứng đáng với số tiền bỏ ra. Vì vậy, dù dán loại phim nào, bạn cũng có thể an tâm hài lòng với chất lượng mà chúng mang đến:
                Nếu ưu tiên chọn loại phim cách nhiệt Ceramic vì hiệu suất, hãy chọn Apeax Nano Ceramic PRO có giá tốt hơn 3M Ceramic IR.
                Nếu chọn vì thương hiệu, 3M là hãng lcó uy tín âu năm nhưng giá sẽ cao hơn gấp nhiều lần so với Apeax.`,
            },
        ],
    },
    {
        id: 6,
        bannerServices: require('../assets/services/service6.jpg'),
        defaultImage: require('../assets/icons/services6.png'),
        hoverImage: require('../assets/icons/services6_6.png'),
        title: 'Dịch vụ phủ gầm',
        benefitImage: require('../assets/benafit/benafit6.png'),
        benefit: 'phủ gầm',
        benefitContent: [
            {
                benefitHead: 'Chống rỉ sét và ăn mòn',
                benefixDescription:
                    'Sơn phủ gầm xe ô tô giúp ngăn chặn sự tiếp xúc trực tiếp của các chi tiết kim loại với mặt đường. Đồng thời tránh bị oxy hóa, tăng độ bền và đảm bảo khả năng vận hành trong trạng thái tốt nhất. Chống rỉ sét, chống ăn mòn khung gầm xe vào mùa mưa do nước bẩn, dầu mỡ, hóa chất, mưa axit, sương, hơi muối biển,…',
            },
            {
                benefitHead: 'Giảm độ rung và chống ồn',
                benefixDescription:
                    'Lớp phủ gầm ô tô cao su non sẽ hấp thụ một phần những tạp âm và rung động nhỏ gây khó chịu, tạo sự thoải mái khi lái xe. Hiệu quả phát huy rõ rệt khi đi qua những con đường ổ gà, không bằng phẳng',
            },
            {
                benefitHead: 'Chống biến dạng, giảm trầy xước',
                benefixDescription:
                    'Sơn phủ gầm ô tô tại trung tâm Vietnam Car Care giúp che chắn và giảm sự hình thành ma sát tránh tạo ra những vết xước bề mặt các chi tiết bên dưới xe hoặc làm bong tróc lớp sơn bóng.',
            },
            {
                benefitHead: 'Tăng cường khả năng cách nhiệt',
                benefixDescription:
                    'Nhiệt độ từ mặt đường có thể lên đến 60 độ vào ngày nắng nóng, phủ gầm xe ô tô giúp hạn chế hấp thụ nhiệt, giảm khí nóng từ mặt đường vào ô tô, tránh làm hệ thống điều hoà hoạt động quá công suất.',
            },
            {
                benefitHead: 'Tăng tính tuổi thọ, tính thẩm mỹ',
                benefixDescription:
                    'Chi phí dịch vụ phủ gầm xe ô tô chất lượng không quá cao, lớp sơn phủ gầm giúp các chi tiết, bộ phận bên dưới gầm xe giữ được vẻ đẹp nguyên bản, bảo vệ và chống lại những chất ô nhiễm có hại. Tuổi thọ của gầm xe ngày một tăng cao, hạn chế tình trạng nứt, rỉ sét kim loại.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Vệ sinh sạch sẽ toàn bộ khu vực gầm xe',
                stepDescription:
                    'Trước khi phủ gầm ô tô, tiến hành rửa sạch toàn bộ xe với vòi xịt áp suất cao và dung dịch xà phòng có độ pH trung tính. Kết hợp loại bỏ dầu mỡ, bùn đất, cặn bẩn, nhựa đường,… bằng dung dịch vệ sinh bề mặt chuyên dụng giúp trả lại vẻ ngoài ban đầu của khung gầm ô tô. Chà giấy nhám mịn để làm phẳng các vết xước.',
            },
            {
                stepHead: 'Bước 2: Che chắn các chi tiết quan trọng',
                stepDescription:
                    'Che chắn toàn bộ các chi tiết, bộ phận quan trọng như hệ thống phanh, các đường ống dầu, động cơ, hộp số, vi sai, đường ống xả, ống pô, thân vỏ bên ngoài xe,… bằng nilon và băng keo giấy trước khi xịt phủ gầm ô tô, tránh để dung dịch phủ gầm dính vào gây mất thẩm mỹ xe.',
            },
            {
                stepHead: 'Bước 3: Thực hiện sơn phủ lớp lót gầm',
                stepDescription:
                    'Sơn lớp lót mỏng trên bề mặt các chi tiết bên dưới gầm xe. Hầu hết các sản phẩm sơn lót đều chứa lượng kẽm phù hợp, giúp lớp sơn nguyên bản gầm xe tránh bị ăn mòn.',
            },
            {
                stepHead: 'Bước 4: Thêm lớp phủ gầm ô tô ngoài cùng',
                stepDescription:
                    'Phủ gầm ô tô theo từng lớp mỏng tùy theo gói dịch vụ mà khách hàng lựa chọn. Lớp phủ dày giúp bảo vệ tốt hơn. Thời gian chờ một lớp phủ gầm xe khô cứng khoảng thường mất khoảng 1-2 giờ. Thao tác thực hiện sơn phủ nhẹ nhàng, di chuyển tay xịt với tốc độ vừa phải, với 3-5 lớp phủ.',
            },
            {
                stepHead: 'Bước 5: Vệ sinh xe sau khi phủ gầm ô tô',
                stepDescription:
                    'Sau khi lớp phủ gầm khô cứng hoàn toàn, kỹ thuật viên sẽ gỡ bỏ lớp nilon, băng keo giấy và vệ sinh khô một lần nữa rước khi bàn giao xe cho khách hàng.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Khi nào nên phủ gầm ô tô?',
                description:
                    'Phủ gầm ô tô phát huy hiệu quả tốt nhất sau khi bạn mới mua xe vì chúng chưa chịu nhiều tác động từ môi trường. Quy trình phủ gầm cho ô tô mới sẽ nhanh chóng hơn, chống ăn mòn tốt, giảm hư hỏng do rỉ sét cao hơn. Lúc này, lớp phủ sẽ tạo được độ liên kết tối đa với lớp sơn bề mặt chi tiết.',
            },
            {
                id: 2,
                text: 'Có nên tự phủ gầm ô tô tại nhà?',
                description:
                    'Bạn có thể tìm thấy sản phẩm phủ gầm ô tô tại rất nhiều cửa hàng chuyên cung cấp sản phẩm chăm sóc xe ô tô để thực hiện tại nhà. Tuy nhiên, bạn sẽ gặp khó khăn và bất lợi khi công việc này đòi hỏi phải có thiết bị chuyên dụng như cầu nâng, súng phun, màng bọc nilon chi tiết chuyên dụng.Hơn hết, không phải bộ phận nào bên dưới gầm xe cũng đều có thể sơn phủ. Mọi thứ cần được che chắn kỹ. Nếu bạn không am hiểu về kỹ thuật ô tô, bạn sẽ không chú ý đến những bộ phận quan trọng này. Đồng thời, thao tác phun cũng cần chuyên nghiệp, đều tay,… và tốt nhất bạn không nên tự phủ gầm ô tô tại nhà.',
            },
            {
                id: 3,
                text: 'Sơn phủ gầm ô tô có chống ồn hay không?',
                description:
                    'Có, một số loại sơn phủ gầm xe giúp làm giảm đáng kể tiếng ồn trên đường, tuy nhiên không phải là giải pháp cách âm hoàn toàn. Lớp phủ bên dưới gầm xe tốt nhất để giảm tiếng ồn được làm bằng hợp chất cao su không bị nứt hoặc giòn theo thời gian. Lớp phủ gầm sẽ giảm ít nhất khoảng 5 dB (decibel), và có thể nhiều hơn thế.',
            },
            {
                id: 4,
                text: 'Chế độ bảo hành sơn phủ gầm ô tô tại L&K Tech?',
                description:
                    '5 năm bảo hành lớp phủ gầm ô tô không bong rộp, tróc nứt, ố hay gỉ sét các chi tiết được phủ.',
            },
        ],
    },
    {
        id: 7,
        bannerServices: require('../assets/services/service7.jpg'),
        defaultImage: require('../assets/icons/services7.png'),
        hoverImage: require('../assets/icons/services7_7.png'),
        title: 'Dịch vụ vệ sinh khoang máy',
        benefit: 'vệ sinh khoang máy',
        benefitImage: require('../assets/benafit/benafit7.png'),
        benefitContent: [
            {
                benefitHead: 'Hạn chế động vật, côn trùng gây hại',
                benefixDescription:
                    'Thông qua quá trình vệ sinh khoang máy và phủ dưỡng Ceramic động cơ, chất thải của chuột, bọ,... được loại bỏ triệt để. Hạn chế làm ổ, tạo mùi hôi trong khoang máy ô tô gây ảnh hưởng đến hệ thống điều hòa không khí trong khoang nội thất ô tô.',
            },
            {
                benefitHead: 'Chống rỉ sét, bám bẩn khoang máy',
                benefixDescription:
                    'Vệ sinh khoang máy đúng cách sẽ ngăn chặn tình trạng bị oxy hóa, rỉ sét, nứt, nhão các chi tiết trong khoang động cơ như dây điện, đường ống cao su, nhựa nhám,.... bằng lớp phủ Ceramic dưỡng bề mặt chuyên dụng hơn 12 tháng.',
            },
            {
                benefitHead: 'Kịp thời phát hiện hư hỏng',
                benefixDescription:
                    'Rất nhiều chủ xe hiện nay không có thói quen mở khoang máy để kiểm tra hoặc vệ sinh định kỳ. Khoang động cơ có thể bị chuột, bọ xâm nhập, gây hại lớn. Khi vệ sinh khoang máy, kỹ thuật viên của Vietnam Car Care sẽ kiểm tra toàn bộ tình trạng động cơ, kịp thời phát hiện và ngăn chặn hư hỏng xảy ra',
            },
            {
                benefitHead: 'Cải thiện hiệu suất, độ bền',
                benefixDescription:
                    'Bụi bẩn, bùn đất, dầu mỡ thừa trong quá trình hoạt động tích tụ nhiều trên bề mặt gây cản trở khả năng thoát nhiệt làm động cơ mau nóng hơn, tiêu hao nhiều nhiên liệu. Bên cạnh đó, các giắc, cảm biến nếu dính phải bùn đất, bụi bẩn sẽ cản trở đường truyền tín hiệu đến ECU khiến động cơ phản hồi chậm.',
            },
            {
                benefitHead: 'Tiết kiệm chi phí sửa chữa, bảo dưỡng',
                benefixDescription:
                    'Sau khi dọn sạch cặn chất bẩn bám trong khoang máy, tiến hành phủ dưỡng chi tiết bên trong. Dung dịch dưỡng nhựa, cao su giúp khôi phục lại vẻ ngoài ban đầu của các chi tiết, hạn chế tình trạng bị lưu hóa bởi nhiệt độ.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1:  Kiểm tra trình trạng khoang máy ô tô',
                stepDescription:
                    'Kỹ thuật viên kiểm tra tình trạng hoạt động của các chi tiết bên trong, đảm bảo không gặp bất kỳ vấn đề gì liên quan đến động cơ hay hệ thống điện.',
            },
            {
                stepHead: 'Bước 2: Che chắn kỹ lưỡng các chi tiết bên trong',
                stepDescription:
                    'Siết chặt hoặc cố định các nắp, vòng đệm tránh nước len lỏi vào bên trong. Sử băng keo giấy và nilon chuyên dụng để bịt kín đường điện hở, đầu giắc, hộp cầu chì, họng gió,...',
            },
            {
                stepHead: 'Bước 3:loại bỏ bụi bẩn và xịt nước làm ướt bề mặt',
                stepDescription:
                    'Xịt gió mạnh để loại bỏ cơ bản các chất bẩn, lá cây,... bám trong khoang máy. Xịt nước áp lực nhẹ làm ướt toàn bộ bề mặt và mặt dưới nắp capo bằng dung dịch tẩy rửa chuyên dụng.',
            },
            {
                stepHead: 'Bước 4: Làm mềm chất bẩn',
                stepDescription:
                    'Phủ đều dung dịch vệ sinh khoang máy ô tô lên toàn bộ các bề mặt. Chờ 5-10 phút cho dung dịch thẩm thấu làm mềm các vết bụi, chất bẩn,…',
            },
            {
                stepHead: 'Bước 5: Cọ rửa khoang máy bằng dụng cụ chuyên dụng',
                stepDescription:
                    'Sử dụng cọ để quét các chất bẩn bám. Trường hợp vết bẩn quá cứng, xịt trực tiếp vào để có thể làm sạch nhanh hơn. Nên chia khoang máy ra làm 4 phần và vệ sinh dứt điểm từng phần một.',
            },
            {
                stepHead: 'Bước 6:Xịt nước áp lực nhẹ tới mạnh rửa trôi chất bẩn',
                stepDescription:
                    'Kiểm tra và che chắn kỹ lại các chi tiết điện đảm bảo rằng khi xịt nước áp lực mạnh sẽ không bị ảnh hưởng. Phun nước từ nắp capo xuống, kết hợp xịt bên dưới động cơ tránh áp lực quá lớn.',
            },
            {
                stepHead: 'Bước 7: Dùng súng xịt khô và khăn lau khô',
                stepDescription:
                    'Tiến hành tháo bỏ các băng keo, nilon đã sử dụng. Chắc chắn rằng các chi tiết đều được làm khô bằng súng xịt khô. Kết hợp dùng khăn Microfiber để thấm khô ngay sau đó.',
            },
            {
                stepHead: 'Bước 8: Kiểm tra cuối',
                stepDescription:
                    'Khởi động máy để đảm bảo xe vận hành trong trạng thái bình thường. Sau đó để máy nổ trong khoảng 5 phút để hâm khô toàn bộ các chi tiết trong khoang máy..',
            },
            {
                stepHead: 'Bước 9: Phủ dưỡng các chi tiết nhựa, cao su',
                stepDescription:
                    'Thực hiện giai đoạn phủ dưỡng toàn bộ chi tiết nhựa, cao su bên trong khoang máy. Kết thúc quá trình vệ sinh khoang máy ô tô.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Bao lâu nên dọn vệ sinh khoang máy ô tô?',
                description:
                    'Theo khuyến cáo, khoang động cơ ô tô nên được làm sạch, vệ sinh chuyên sâu từ 3 tháng. Nếu môi trường lái và tần suất sử dụng thường xuyên với các chặng đường dài, thời gian vệ sinh khoang máy ô tô được rút ngắn, tùy thuộc vào tình trạng bám cặn bẩn của mỗi xe.',
            },
            {
                id: 2,
                text: 'Có nên tự vệ sinh khoang máy ô tô tại nhà?',
                description:
                    'Nếu bạn chưa có kiến thức về động cơ ô tô, chúng tôi khuyên bạn không nên tự thực hiện tại nhà để đảm bảo an toàn cho chiếc xe. Việc xịt rửa không đúng cách có thể khiến động cơ bị chập hệ thống điện. Bạn có thể loại bỏ bụi bẩn trên bề mặt tại nhà bằng các dụng cụ như cọ, chổi quét,…',
            },
            {
                id: 3,
                text: 'Cam kết của L&K Tech khi vệ sinh khoang máy xe hơi cho khách hàng?',
                description:
                    'L&K Tech cam kết thực hiện đúng quy trình vệ sinh động cơ theo chuẩn Detailing, không rút ngắn hay bỏ sót bước nào, dù là nhỏ nhất. Ngoài ra, chúng tôi cam kết làm sạch 97% khoang động cơ vì những chi tiết ẩn sâu bên trong cần phải tháo máy, rất khó vệ sinh thủ công. Đặc biệt nhất là với các dòng xe Đức như Audi, BMW, Mercedes-Benz, chúng có cấu tạo khoang máy phức tạp.Nếu bạn muốn làm sạch triệt để hơn, Vietnam Car Care có thêm phương pháp làm sạch mới, vệ sinh khoang máy ô tô bằng hơi nước nóng, Cách làm này được chứng minh an toàn, giúp làm mềm các chất bẩn tốt hơn và gia tăng hiệu quả làm sạch khoang động cơ tối ưu.',
            },
            {
                id: 4,
                text: 'Thời gian vệ sinh động cơ xe ô tô mất bao lâu?',
                description: 'Thông thường, dịch vụ vệ sinh động cơ ô tô toàn diện, chi tiết sẽ mất khoảng 2 tiếng.',
            },
            {
                id: 5,
                text: 'Xịt nước vào khoang máy ô tô có an toàn?',
                description:
                    'Bạn có thể xịt nước vào khoang động cơ nhưng cần phải che chắn, bịt kín kỹ lưỡng các chi tiết, bộ phận dễ bị ảnh hưởng. Nếu không cẩn thận, nước sẽ lọt vào đường hút gió, khe kẽ trong động cơ làm quá trình đánh lửa gặp vấn đề lớn. Chắc hẳn bạn sẽ không muốn chiếc xe của mình bị hụt hơi khi đạp ga, nhiều khói xám,… hoặc nặng hơn là bó máy hay chập hệ thống điện đâu phải không?',
            },
        ],
    },
    {
        id: 8,
        bannerServices: require('../assets/services/service8.jpg'),
        defaultImage: require('../assets/icons/services8.png'),
        hoverImage: require('../assets/icons/services8_8.png'),
        title: 'Dịch vụ kiểm tra chẩn đoán',
        benefit: 'kiểm tra chẩn đoán sự cố điện',
        benefitImage: require('../assets/benafit/benafit8.png'),
        benefitContent: [
            {
                benefitHead: 'Phát hiện sớm các vấn đề tiềm ẩn',
                benefixDescription:
                    'Kiểm tra chẩn đoán hệ thống điện giúp phát hiện sớm các lỗi nhỏ trước khi chúng phát triển thành sự cố nghiêm trọng, từ đó giúp bạn tiết kiệm chi phí sửa chữa.',
            },
            {
                benefitHead: 'Đảm bảo an toàn khi lái xe',
                benefixDescription:
                    'Hệ thống điện đóng vai trò quan trọng trong việc điều khiển và vận hành các bộ phận an toàn như hệ thống đèn, còi, cảm biến, và hệ thống phanh điện tử. Việc kiểm tra định kỳ giúp đảm bảo các bộ phận này luôn hoạt động đúng cách, tăng cường sự an toàn cho bạn khi lái xe.',
            },
            {
                benefitHead: 'Tối ưu hóa hiệu suất của các thiết bị điện',
                benefixDescription:
                    'Việc kiểm tra định kỳ đảm bảo rằng các thiết bị điện như đèn, điều hòa, hệ thống giải trí, và hệ thống khởi động luôn hoạt động với hiệu suất cao nhất, mang lại trải nghiệm thoải mái và tiện nghi.',
            },
            {
                benefitHead: 'Tiết kiệm chi phí sửa chữa',
                benefixDescription:
                    'Phát hiện và khắc phục sớm các lỗi điện giúp tránh được các sự cố nghiêm trọng và tốn kém. Bảo trì định kỳ có chi phí thấp hơn rất nhiều so với sửa chữa hoặc thay thế toàn bộ hệ thống điện khi gặp sự cố lớn.',
            },
            {
                benefitHead: 'Đảm bảo sự ổn định của hệ thống điện tử',
                benefixDescription:
                    'Với các xe hiện đại ngày nay, hệ thống điện tử liên quan chặt chẽ đến các chức năng như định vị GPS, cảm biến va chạm, và hệ thống điều khiển từ xa. Kiểm tra định kỳ giúp các hệ thống này hoạt động ổn định, tăng tính tiện ích và an toàn.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Kiểm tra hệ thống ắc quy và điện áp',
                stepDescription:
                    'Bắt đầu bằng việc kiểm tra tình trạng của ắc quy, đo điện áp để đảm bảo ắc quy đang hoạt động ở mức điện áp chuẩn (thường là từ 12.6V đến 12.8V khi không tải).Xem xét các đầu cáp, cọc ắc quy có bị lỏng hoặc oxi hóa không và vệ sinh nếu cần thiết.',
            },
            {
                stepHead: 'Bước 2: Kiểm tra hệ thống khởi động và máy phát điện',
                stepDescription:
                    'Đánh giá tình trạng của hệ thống khởi động bằng cách đo điện áp khi khởi động xe để kiểm tra xem có đủ dòng điện hay không.Kiểm tra máy phát điện để đảm bảo nó đang nạp điện cho ắc quy đúng cách. Đo điện áp nạp khi động cơ đang chạy (thường từ 13.5V đến 14.5V).',
            },
            {
                stepHead: 'Bước 3:  Kiểm tra cầu chì và hệ thống rơ-le',
                stepDescription:
                    'Kiểm tra tất cả các cầu chì để đảm bảo không có cầu chì nào bị cháy hoặc hư hỏng.Kiểm tra các rơ-le điều khiển các thiết bị quan trọng như đèn, còi, quạt gió để đảm bảo chúng hoạt động đúng.',
            },
            {
                stepHead: 'Bước 4: Sử dụng máy quét mã lỗi OBD-II',
                stepDescription:
                    'Kết nối máy quét mã lỗi OBD-II vào cổng OBD của xe để lấy mã lỗi từ ECU (hộp điều khiển trung tâm).Đọc các mã lỗi và phân tích các lỗi liên quan đến hệ thống điện tử và điện trên xe.',
            },
            {
                stepHead: 'Bước 5: Kiểm tra hệ thống đèn và các thiết bị điện khác:',
                stepDescription:
                    'Kiểm tra toàn bộ hệ thống đèn, bao gồm đèn pha, đèn xi nhan, đèn hậu, và đèn nội thất để đảm bảo chúng hoạt động bình thường.Kiểm tra các thiết bị điện khác như điều hòa, hệ thống giải trí, cửa sổ điện, và gương chiếu hậu điện.',
            },
            {
                stepHead: 'Bước 6: Đánh giá hệ thống cảm biến và dây điện',
                stepDescription:
                    'Kiểm tra các cảm biến như cảm biến tốc độ, cảm biến nhiệt độ động cơ, và các cảm biến an toàn để đảm bảo chúng đang gửi tín hiệu đúng đến ECU.Đánh giá hệ thống dây điện để kiểm tra xem có dấu hiệu đứt, chập hoặc gãy dây nào không.',
            },
            {
                stepHead: 'Bước 7: Kiểm tra hệ thống tiếp đất:',
                stepDescription:
                    'Xem xét các điểm tiếp đất chính của xe để đảm bảo chúng sạch sẽ và không bị rỉ sét, giúp hệ thống điện hoạt động ổn định.',
            },
            {
                stepHead: 'Bước 8: Thực hiện kiểm tra mạch điện chi tiết',
                stepDescription:
                    'Dùng dụng cụ đo điện để kiểm tra từng mạch điện cụ thể (như mạch điều khiển đèn, mạch điều hòa) để tìm ra vị trí gây lỗi.',
            },
            {
                stepHead: 'Bước 9: Cập nhật và kiểm tra lại mã lỗi sau sửa chữa',
                stepDescription:
                    'Sau khi khắc phục các sự cố, dùng máy quét mã lỗi OBD-II để xóa mã lỗi và chạy lại kiểm tra để đảm bảo không còn mã lỗi nào tồn tại.',
            },
            {
                stepHead: 'Bước 10: Lưu lại kết quả chẩn đoán và sửa chữa',
                stepDescription:
                    'Ghi chép lại tất cả các bước đã thực hiện và kết quả kiểm tra, mã lỗi đã gặp phải, và các bước sửa chữa để tiện theo dõi trong các lần bảo dưỡng tiếp theo.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Tại sao tôi cần phải chẩn đoán xe ô tô định kỳ?',
                description:
                    'Chẩn đoán định kỳ giúp phát hiện sớm các vấn đề nhỏ trước khi chúng trở thành hư hỏng lớn, gây tốn kém chi phí sửa chữa và đảm bảo an toàn khi lái xe. Ngoài ra, chẩn đoán còn giúp kéo dài tuổi thọ của xe và duy trì hiệu suất hoạt động tối ưu.',
            },
            {
                id: 2,
                text: 'Chẩn đoán ô tô bao gồm những gì?',
                description: `Kiểm tra tổng quát các hệ thống trên xe: động cơ, hệ thống làm mát, hệ thống phanh, hệ thống treo, hệ thống điện...
                              Sử dụng máy chẩn đoán chuyên dụng để đọc mã lỗi và phân tích dữ liệu.
                              Kiểm tra các mức chất lỏng, áp suất lốp, tình trạng dây đai, bugi...
                              Thử nghiệm lái xe để đánh giá cảm giác lái và phát hiện các tiếng ồn bất thường.`,
            },
            {
                id: 3,
                text: 'Chẩn đoán ô tô có tốn nhiều thời gian không?',
                description:
                    'Thời gian chẩn đoán phụ thuộc vào nhiều yếu tố như: tình trạng xe, loại xe, các thiết bị chẩn đoán được sử dụng. Thông thường, quá trình chẩn đoán cơ bản sẽ mất từ 30 phút đến 1 giờ. Tuy nhiên, nếu phát hiện vấn đề phức tạp, thời gian có thể kéo dài hơn.',
            },
            {
                id: 4,
                text: 'Làm sao tôi biết nên chọn gara nào để chẩn đoán xe?',
                description:
                    'Bạn nên chọn gara có uy tín, được nhiều người tin tưởng, có đội ngũ kỹ thuật viên giàu kinh nghiệm và sử dụng các thiết bị chẩn đoán hiện đại. Ngoài ra, bạn có thể tham khảo ý kiến của bạn bè, người thân hoặc tìm kiếm thông tin trên các diễn đàn ô tô.',
            },
        ],
    },
    {
        id: 9,
        bannerServices: require('../assets/services/service9.jpg'),
        defaultImage: require('../assets/icons/services9.png'),
        hoverImage: require('../assets/icons/services9_9.png'),
        title: 'Dịch vụ thay dầu nhớt',
        benefit: 'thay dầu nhớt',
        benefitImage: require('../assets/benafit/benafit9.png'),
        benefitContent: [
            {
                benefitHead: 'Bảo vệ động cơ',
                benefixDescription:
                    'Thay dầu nhớt định kỳ giúp loại bỏ cặn bẩn và mạt kim loại tích tụ trong động cơ, giúp bôi trơn các chi tiết máy một cách hiệu quả, giảm ma sát và hạn chế mài mòn.',
            },
            {
                benefitHead: 'Tăng hiệu suất hoạt động',
                benefixDescription:
                    'Dầu nhớt mới giúp động cơ hoạt động mượt mà hơn, giảm nhiệt độ và tối ưu hóa quá trình đốt cháy, từ đó cải thiện hiệu suất và tiết kiệm nhiên liệu.',
            },
            {
                benefitHead: 'Duy trì tuổi thọ của động cơ',
                benefixDescription:
                    'Thay dầu nhớt đúng hạn giúp duy trì lớp bảo vệ giữa các chi tiết động cơ, ngăn ngừa sự hao mòn và hư hỏng sớm, kéo dài tuổi thọ của xe.',
            },
            {
                benefitHead: 'Giảm thiểu khí thải',
                benefixDescription:
                    'Dầu nhớt sạch giúp động cơ hoạt động hiệu quả hơn, giảm lượng nhiên liệu chưa cháy hết và hạn chế lượng khí thải độc hại ra môi trường.',
            },
            {
                benefitHead: ' Hỗ trợ hệ thống làm mát:',
                benefixDescription:
                    'Dầu nhớt không chỉ bôi trơn mà còn có vai trò giúp làm mát động cơ. Khi dầu nhớt mới và sạch, khả năng làm mát của động cơ được duy trì, giảm nguy cơ quá nhiệt.',
            },
            {
                benefitHead: 'Tiết kiệm chi phí sửa chữa',
                benefixDescription:
                    'Thay dầu nhớt định kỳ là một biện pháp bảo dưỡng cơ bản nhưng quan trọng, giúp phát hiện và ngăn ngừa các vấn đề tiềm ẩn trong động cơ, giảm nguy cơ phải sửa chữa tốn kém trong tương lai.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Kiểm tra và chuẩn bị',
                stepDescription:
                    'Đặt xe vào vị trí an toàn, nhấc nắp capo và kiểm tra mức dầu hiện tại bằng que thăm dầu. Chuẩn bị đầy đủ các dụng cụ và vật liệu cần thiết như dầu nhớt mới, bộ lọc dầu, phễu và khay hứng dầu thải.',
            },
            {
                stepHead: 'Bước 2: Xả dầu cũ',
                stepDescription:
                    'Đặt khay hứng dầu dưới cacte (đáy động cơ), mở ốc xả dầu để dầu cũ chảy ra hết. Chờ vài phút để dầu cũ xả hoàn toàn, đảm bảo loại bỏ tất cả các cặn bẩn và tạp chất có trong động cơ.',
            },
            {
                stepHead: 'Bước 3: Thay bộ lọc dầu',
                stepDescription:
                    'Dựa vào độ dày mỏng khác nhau của sơn cũng như tình trạng khiếm khuyết sơn, kỹ thuật viên sẽ sử dụng kết hợp máy đánh bóng và xi đánh bóng xe ô tô để làm mịn và phẳng các vết xước, vết xoáy,…',
            },
            {
                stepHead: 'Bước 4: Đóng ốc xả dầu',
                stepDescription:
                    ' Sau khi dầu cũ đã xả hết, vặn chặt lại ốc xả dầu bằng dụng cụ chuyên dụng để đảm bảo không có rò rỉ.',
            },
            {
                stepHead: 'Bước 5: Đổ dầu nhớt mới',
                stepDescription:
                    'Sử dụng phễu để đổ dầu nhớt mới vào động cơ qua nắp châm dầu. Đổ từ từ và kiểm tra mức dầu bằng que thăm dầu để đảm bảo mức dầu đạt chuẩn (thường nằm giữa hai vạch MIN và MAX).',
            },
            {
                stepHead: 'Bước 6: Khởi động và kiểm tra',
                stepDescription:
                    'Khởi động xe và để động cơ chạy không tải trong vài phút. Kiểm tra xem có rò rỉ dầu không và đảm bảo động cơ hoạt động êm ái.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Bao lâu thì nên thay dầu nhớt một lần?',
                description:
                    'Tùy vào loại dầu và điều kiện sử dụng, thường thì nên thay dầu sau mỗi 5.000 - 10.000 km hoặc sau 6 tháng (tùy theo điều kiện nào đến trước). Kiểm tra hướng dẫn sử dụng của xe hoặc tư vấn từ chuyên gia để có lịch thay dầu chính xác.',
            },
            {
                id: 2,
                text: 'Tại sao việc thay dầu nhớt định kỳ lại quan trọng?',
                description:
                    'Dầu nhớt giúp bôi trơn các bộ phận trong động cơ, làm mát và giảm ma sát. Thay dầu định kỳ giúp giữ cho động cơ hoạt động hiệu quả, giảm mài mòn và kéo dài tuổi thọ của xe.',
            },
            {
                id: 3,
                text: 'Cần lưu ý đến vị trí nào khi vệ sinh nội thất ô tô?',
                description:
                    'Có rất nhiều vị trí cần lưu ý khi vệ sinh nội thất ô tô, dù lại tại nhà hay tại trung tâm chăm sóc xe. Một số vị trí cần lưu ý bao gồm nấm mốc bên dưới ghế ngồi, khe gió điều hòa, ron cửa sổ, dây đai, hộc đựng đồ, vải lót đựng đồ sau ghế, trần nỉ, thảm lót cốp,…',
            },
            {
                id: 4,
                text: ' Loại dầu nhớt nào phù hợp với xe của tôi?',
                description:
                    'Loại dầu nhớt phù hợp phụ thuộc vào hãng xe và dòng xe. Bạn nên kiểm tra hướng dẫn sử dụng hoặc hỏi ý kiến chuyên gia để lựa chọn loại dầu phù hợp (dầu tổng hợp, bán tổng hợp hoặc dầu gốc khoáng).',
            },
            {
                id: 5,
                text: 'Tôi có thể tự thay dầu nhớt tại nhà không?',
                description:
                    'Có thể, nhưng bạn cần có đủ dụng cụ và kiến thức cơ bản về ô tô. Tuy nhiên, để đảm bảo an toàn và đúng kỹ thuật, nên đưa xe đến các trung tâm dịch vụ uy tín như L&K TECH.',
            },
        ],
    },
    {
        id: 10,
        bannerServices: require('../assets/services/service10.jpg'),
        defaultImage: require('../assets/icons/services10.png'),
        hoverImage: require('../assets/icons/services10_10.png'),
        title: 'Dịch vụ rửa xe',
        benefit: 'rửa xe',
        benefitImage: require('../assets/benafit/benafit10.png'),
        benefitContent: [
            {
                benefitHead: ' Bảo vệ sơn xe',
                benefixDescription:
                    'Dọn rửa xe thường xuyên giúp loại bỏ bụi bẩn, cặn bã, nhựa cây, và các chất ô nhiễm khác bám trên bề mặt xe, ngăn ngừa chúng ăn mòn lớp sơn và làm hỏng bề mặt xe. Điều này giúp duy trì độ bóng và màu sắc của sơn xe lâu hơn.',
            },
            {
                benefitHead: 'Ngăn ngừa rỉ sét:',
                benefixDescription:
                    'Các chất bẩn, muối đường và hóa chất có thể tích tụ trên các chi tiết kim loại của xe, đặc biệt là gầm xe, gây ra hiện tượng ăn mòn và rỉ sét. Việc dọn rửa xe kỹ lưỡng giúp loại bỏ các yếu tố gây hại này, bảo vệ các chi tiết kim loại.',
            },
            {
                benefitHead: 'Tăng giá trị xe',
                benefixDescription:
                    'Một chiếc xe được giữ gìn và bảo quản tốt, cả về ngoại thất lẫn nội thất, sẽ giữ giá trị cao hơn khi bán lại. Xe sạch sẽ và bóng bẩy thường thu hút người mua hơn, cho thấy chủ xe quan tâm và chăm sóc tốt cho xe.',
            },
            {
                benefitHead: 'Tạo cảm giác thoải mái',
                benefixDescription:
                    ' Một chiếc xe sạch sẽ không chỉ mang lại cảm giác thoải mái cho người lái mà còn cho hành khách, tạo nên một môi trường lái xe dễ chịu và thoải mái hơn. Việc dọn dẹp thường xuyên giúp duy trì mùi thơm và không gian thoáng mát bên trong xe.',
            },
            {
                benefitHead: 'Phát hiện sớm các vấn đề kỹ thuật',
                benefixDescription:
                    'Khi dọn rửa xe, bạn có cơ hội kiểm tra các chi tiết bên ngoài như lốp xe, kính chắn gió, gương, và các chi tiết khác để phát hiện sớm các vết nứt, trầy xước hoặc các dấu hiệu bất thường cần khắc phục.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Chuẩn bị dụng cụ và xe',
                stepDescription:
                    'Trước khi bắt đầu, chuẩn bị các dụng cụ cần thiết như xô nước, khăn mềm, bọt biển, chất tẩy rửa chuyên dụng cho xe, và máy phun nước áp lực. Kiểm tra và đảm bảo xe đã nguội để tránh làm hỏng sơn khi rửa.',
            },
            {
                stepHead: 'Bước 2: Phun nước loại bỏ bụi bẩn ban đầu:',
                stepDescription:
                    ' Sử dụng máy phun nước áp lực nhẹ để phun toàn bộ bề mặt xe, giúp loại bỏ bụi bẩn và cặn bã lớn bám trên xe. Bước này giúp làm mềm các chất bẩn, ngăn ngừa trầy xước khi rửa.',
            },
            {
                stepHead: 'Bước 3: Sử dụng dung dịch rửa xe',
                stepDescription:
                    'Pha dung dịch rửa xe chuyên dụng vào xô nước và dùng bọt biển hoặc khăn mềm nhúng vào, sau đó rửa từng phần của xe theo thứ tự từ trên xuống dưới để tránh vết bẩn lan xuống phần đã làm sạch.',
            },
            {
                stepHead: 'Bước 4: Rửa kỹ các chi tiết:',
                stepDescription:
                    'Chú ý làm sạch các khu vực khó tiếp cận như bánh xe, gương, khe cửa, và cản xe. Sử dụng bàn chải mềm để cọ rửa bánh xe và các khe hở để đảm bảo loại bỏ hết cặn bẩn bám vào.',
            },
            {
                stepHead: 'Bước 5: Rửa lại bằng nước sạch',
                stepDescription:
                    'Sau khi dùng dung dịch rửa xe, phun nước sạch để loại bỏ toàn bộ xà phòng và chất bẩn còn lại. Hãy đảm bảo không để lại xà phòng trên xe vì có thể làm mất độ bóng của sơn.',
            },
            {
                stepHead: 'Bước 6: Lau khô xe:',
                stepDescription:
                    'Sử dụng khăn sợi mềm để lau khô toàn bộ bề mặt xe. Bắt đầu từ nóc xe và lau xuống dưới để đảm bảo không để lại vệt nước và giúp xe bóng đẹp hơn.',
            },
            {
                stepHead: 'Bước 7: Sử dụng dung dịch bảo vệ sơn',
                stepDescription:
                    'Sau khi xe đã khô, có thể dùng dung dịch bảo vệ sơn hoặc sáp xe để tạo lớp bảo vệ, giúp duy trì độ bóng và bảo vệ bề mặt khỏi tác nhân gây hại từ môi trường.',
            },
            {
                stepHead: 'Bước 8: Kiểm tra lần cuối',
                stepDescription:
                    ' Kiểm tra toàn bộ bề mặt xe để đảm bảo không bỏ sót bất kỳ vết bẩn nào. Đồng thời, kiểm tra các chi tiết như gương, kính chắn gió, và lốp xe để đảm bảo mọi thứ sạch sẽ.',
            },
        ],
        question: [
            {
                id: 1,
                text: ' Bao lâu nên rửa xe một lần?',
                description:
                    'Nên rửa xe ít nhất mỗi tuần một lần hoặc khi xe bám bụi bẩn nhiều. Tuy nhiên, tần suất này có thể thay đổi tùy thuộc vào điều kiện môi trường và mức độ sử dụng xe của bạn. Rửa xe thường xuyên giúp bảo vệ lớp sơn và duy trì vẻ ngoài sạch đẹp.',
            },
            {
                id: 2,
                text: 'Rửa xe tại nhà hay đến tiệm rửa xe chuyên nghiệp?',
                description:
                    'Rửa xe tại nhà có thể tiết kiệm chi phí, nhưng nếu không sử dụng đúng sản phẩm và kỹ thuật, bạn có thể làm hỏng lớp sơn. Rửa xe tại tiệm chuyên nghiệp đảm bảo xe được làm sạch kỹ lưỡng và bảo vệ tốt nhất với các dụng cụ và dung dịch chuyên dụng.',
            },
            {
                id: 3,
                text: 'Rửa xe bằng nước thông thường có tốt không?',
                description:
                    'Không nên rửa xe chỉ bằng nước thông thường vì không thể loại bỏ hoàn toàn các chất bẩn và dầu mỡ bám trên xe. Sử dụng dung dịch rửa xe chuyên dụng giúp làm sạch hiệu quả hơn và bảo vệ lớp sơn xe.',
            },
            {
                id: 4,
                text: 'Nên rửa xe khi trời nắng hay trời râm?',
                description:
                    'Tốt nhất nên rửa xe khi trời râm hoặc trong bóng mát vì dưới ánh nắng, nước và xà phòng sẽ khô nhanh, gây ra các vệt nước và làm hỏng sơn. Rửa xe trong điều kiện mát mẻ giúp đảm bảo xe được làm sạch hiệu quả mà không để lại dấu vết.',
            },
        ],
    },
    {
        id: 11,
        bannerServices: require('../assets/services/service11.jpg'),
        defaultImage: require('../assets/icons/services11.png'),
        hoverImage: require('../assets/icons/services11_11.png'),
        title: 'Dịch vụ bảo dưỡng nhanh',
        benefit: 'bảo dưỡng nhanh',
        benefitImage: require('../assets/benafit/benafit11.png'),
        benefitContent: [
            {
                benefitHead: 'Bảo vệ sức khỏe',
                benefixDescription:
                    'Không chỉ làm sạch bên ngoài xe, quá trình chăm sóc xe ô tô toàn diện tại Vietnam Car Care đảm bảo nội thất được vệ sinh an toàn, loại bỏ vi khuẩn, nấm mốc gây hại, giúp môi trường không khí bên trong xe sạch sẽ hơn. Tránh gặp phải các bệnh về đường hô hấp, nhiễm trùng, đường ruột,…',
            },
            {
                benefitHead: 'Kiểm tra, bảo dưỡng kịp thời',
                benefixDescription:
                    'Bằng cách chăm sóc xe ô tô định kỳ và toàn diện tại Vietnam Car Care, bạn có thể tránh được những chi phí sửa chữa đắt tiền do hư hỏng của các bộ phận trong xe. Kỹ thuật viên kiểm tra những nguy cơ hư hỏng tiềm ẩn trên xe như gỉ sét gầm; trầy xước xoáy; đứt dây điện,….',
            },
            {
                benefitHead: 'Duy trì độ bền, tăng tuổi thọ ô tô',
                benefixDescription:
                    'Chăm sóc xe ô tô định kỳ, đúng cách sẽ giúp duy trì độ ổn định và khả năng vận hành tốt hơn. Loại bỏ những chất cặn bẩn, hóa chất,... gây ăn mòn các chi tiết. Hơn nữa, khi sử dụng xe luôn trong tình trạng tốt, bạn sẽ tiết kiệm được nhiều chi phí cho nhiên liệu và bảo dưỡng.',
            },
            {
                benefitHead: 'Tăng tính thẩm mỹ, giá trị xe',
                benefixDescription:
                    'Một chiếc xe được chăm sóc đúng cách sẽ luôn giữ được ngoại hình mới mẻ, bóng bẩy và sạch sẽ. Điều này mang lại niềm tự hào cho chủ xe và thu hút được sự chú ý từ người khác. Hơn nữa, việc chăm sóc xe ô tô toàn diện cũng giúp tăng giá trị bán lại của chiếc xe, dễ "chốt deal" hơn.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: đánh giá sơ bộ',
                stepDescription: 'Đánh giá sơ bộ toàn diện tình trạng xe và báo giá các hạng mục cần thực hiện.',
            },
            {
                stepHead: 'Bước 2: vệ sinh khoang máy',
                stepDescription:
                    'Toàn bộ quá trình chăm sóc xe ô tô toàn diện theo gói cao cấp nhất, bắt đầu từ việc vệ sinh khoang máy.',
            },
            {
                stepHead: 'Bước 3: khử nhiễm bề mặt',
                stepDescription:
                    'Kế đến, tẩy bụi sắt, bụi phanh, nhựa đường, keo dính, bọ,… bám trên mâm lốp, thân xe.',
            },
            {
                stepHead: 'Bước 4: rửa toàn bộ xe',
                stepDescription:
                    'Giặt thảm và rửa xe chi tiết toàn bộ bằng phương pháp rửa xe 3 xô với xà phòng có độ pH trung tính.',
            },
            {
                stepHead: 'Bước 5: tẩy bụi sơn',
                stepDescription: 'Tẩy bụi sơn bằng đất sét chuyên dụng và không cạo bằng dao cạo, tránh trầy xước.',
            },
            {
                stepHead: 'Bước 6: phủ dưỡng nhựa nhám mâm lớp',
                stepDescription:
                    'Kỹ thuật viên sẽ làm đậm màu nhựa nhám, mâm lốp ô tô như ban đầu bằng dung dịch chuyên dụng, tránh bị bạc màu, oxy hóa theo thời gian.',
            },
            {
                stepHead: 'Bước 7: đánh bóng hiệu chỉnh sơn xe',
                stepDescription: 'Tạo độ bóng cao cho lớp sơn, loại bỏ các vết trầy xước xoáy trên bề mặt.',
            },
            {
                stepHead: 'Bước 8: phủ sealant ngoại thất ô tô',
                stepDescription:
                    'Sau khi đánh bóng và hiệu chỉnh sơn xe, kỹ thuật viên tiến hành phủ sealant tăng độ bóng bề mặt với dung dịch IGL Coatings Premier Sealant cao cấp.',
            },
            {
                stepHead: 'Bước 9: hút bụi, vệ sinh nội thất ô tô',
                stepDescription:
                    'Hút sạch từng khe kẽ, ngóc ngách bên trong. Chú ý kỹ đến hốc gió, khe gió, hộp đựng đồ, taplo,… Vệ sinh bề mặt bằng dụng dịch khử khuẩn an toàn với chi tiết nhựa nhám.',
            },
            {
                stepHead: 'Bước 10 khử bụi, diệt khuẩn khoang nội thất',
                stepDescription: 'Sử dụng máy C-Air Fog diệt khuẩn, diệt nấm mốc bên trong khoang nội thất ô tô.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Bao lâu nên chăm sóc xe ô tô toàn diện một lần?',
                description: `Theo lời khuyên của các chuyên gia tại Vietnam Car Care, bạn nên thực hiện chăm sóc xe hơi toàn diện định kỳ 3 tháng/lần, để giảm thiểu tối đa các vi khuẩn, nấm mốc gây ảnh hưởng sức khỏe. Tùy thuộc vào tần suất sử dụng xe:
                            + Nếu bạn thường xuyên di chuyển thì nên vệ sinh khoảng 1 tháng/lần.
                            + Nếu bạn di chuyển ít thì nên chăm sóc xe hơi toàn diện khoảng 2 tháng/lần.`,
            },
            {
                id: 2,
                text: 'Tại sao nên chăm sóc xe ô tô toàn diện tại trung tâm Detailing uy tín?',
                description: `Chúng tôi không đánh đồng với tất cả các trung tâm Detailing uy tín khác tại TP HCM. Tuy nhiên, hiện nay vẫn còn một số cơ sở chăm sóc xe “tự phát”, nghiệp dư, thiếu rất nhiều trang thiết bị chuyên dụng lẫn kỹ thuật cho quá trình chăm sóc xe. Điều này dẫn đến kết quả kém chất lượng và nhiều người thường tự hỏi: “Tại sao xe tôi chăm sóc thường xuyên mà vẫn xuống cấp?”.

Vì vậy, bạn nên chọn và tham khảo những cơ sở trung tâm uy tín chất lượng để đạt hiệu quả dịch vụ chăm sóc xe ô tô tốt nhất có thể, tận dụng triệt để nguồn chi phí sử dụng cho dịch vụ đó.`,
            },
            {
                id: 3,
                text: 'Sơn phủ gầm ô tô có chống ồn hay không?',
                description:
                    'Có, một số loại sơn phủ gầm xe giúp làm giảm đáng kể tiếng ồn trên đường, tuy nhiên không phải là giải pháp cách âm hoàn toàn. Lớp phủ bên dưới gầm xe tốt nhất để giảm tiếng ồn được làm bằng hợp chất cao su không bị nứt hoặc giòn theo thời gian. Lớp phủ gầm sẽ giảm ít nhất khoảng 5 dB (decibel), và có thể nhiều hơn thế.',
            },
            {
                id: 4,
                text: 'Thời gian chăm sóc xe ô tô toàn diện khoảng bao lâu?',
                description:
                    'Tùy vào từng tình trạng thực tế và nhu cầu chăm sóc xe của khách hàng, đối với gói chăm sóc cơ bản (tiêu chuẩn) thông thường chỉ mất khoảng 30 – 45 phút thực hiện. Nếu khách hàng chọn những gói dịch vụ chăm sóc cao cấp hơn thì thời gian có thể dao động khoảng 2 – 3 giờ, thậm chí có thể mất khoảng 4 tiếng với tình trạng bẩn nặng.',
            },
        ],
    },
    {
        id: 12,
        bannerServices: require('../assets/services/service12.jpg'),
        defaultImage: require('../assets/icons/services12.png'),
        hoverImage: require('../assets/icons/services12_12.png'),
        title: 'Dịch vụ độ màn hình android',
        benefit: 'độ màn hình android',
        benefitImage: require('../assets/benafit/benafit12.png'),
        benefitContent: [
            {
                benefitHead: 'Tăng tính hiện đại, sang trọng cho nội thất',
                benefixDescription:
                    'Thiết kế của màn hình android ô tô thế hệ mới tương thích với nhiều dòng xe, hợp thời trang, khớp với phần ốp sẵn của xe. Kích thước màn hình cảm ứng rộng từ 7-10 inch, được cải tiến với mặt kính cường lực tăng thêm phần chắc chắn.',
            },
            {
                benefitHead: 'Cấu hình DVD Android mạnh mẽ',
                benefixDescription:
                    'Ngoài các vết trầy xước, các khiếm khuyết sơn khác thường xuất hiện trên bề mặt như vết xoáy mạng nhện, đốm nước ăn mòn lâu ngày, vết sơn chảy, sơn vỏ cam, mắt cá, bụi sơn,... đều được loại bỏ hoàn toàn, tái tạo lại một bề mặt phẳng mịn như ban đầu.',
            },
            {
                benefitHead: 'Cung cấp tính năng hỗ trợ lái xe an toàn',
                benefixDescription:
                    'Hỗ trợ lái xe an toàn bằng cách điều khiển thông qua giọng nói hoặc qua nút bấm khởi động trên vô lăng để mở nhạc, youtube, nghe gọi, tìm kiếm trên google,… Nâng cao khả năng tập trung lái xe và tránh bị xao nhãng.',
            },
            {
                benefitHead: 'Tối ưu hóa không gian nội thất ô tô',
                benefixDescription:
                    'Trang bị màn hình Android ô tô giúp tối ưu hóa không gian bên trong xe. Thay vì lắp thêm nhiều thiết bị riêng biệt như đầu CD, máy nghe nhạc, màn hình này đã tích hợp các chức năng cần thiết và chiếm ít không gian hơn.',
            },
            {
                benefitHead: 'Ứng dụng chỉ đường thông minh',
                benefixDescription:
                    'Với tính năng GPS tích hợp, màn hình Android ô tô cho phép người lái sử dụng các ứng dụng chỉ đường thông minh như Google Maps, Navitel, Vietmap,... để tìm kiếm và lập kế hoạch tuyến đường, cập nhật tình trạng giao thông trực t iếp hoặc đề xuất các tuyến đường tối ưu,.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1: Chuẩn bị thiết bị và dụng cụ',
                stepDescription: ' Lựa chọn màn hình phù hợp với dòng xe, kích thước và tính năng yêu cầu.',
            },
            {
                stepHead: 'Bước 2: Kiểm tra và chuẩn bị hệ thống hiện tại:',
                stepDescription:
                    'Ngắt kết nối ắc quy xe để đảm bảo an toàn trong quá trình lắp đặt. Tháo màn hình hoặc hệ thống giải trí cũ trên xe. Đảm bảo tháo nhẹ nhàng để tránh làm hỏng các phần nhựa hay dây điện.',
            },
            {
                stepHead: 'Bước 3: Lắp đặt màn hình Android',
                stepDescription:
                    'Kết nối dây nguồn và dây tín hiệu: Kết nối dây nguồn từ màn hình mới vào nguồn của xe (có thể qua giắc cắm có sẵn hoặc đấu nối thủ công). Kết nối dây loa và dây tín hiệu (âm thanh, video) nếu cần thiết. Gắn màn hình vào vị trí: Đặt màn hình Android vào chỗ lắp của màn hình cũ, đảm bảo khớp với các ngàm và vị trí cố định.',
            },
            {
                stepHead: 'Bước 4: Cài đặt phần mềm và cấu hình hệ thống',
                stepDescription:
                    'Khởi động xe và kiểm tra xem màn hình mới có hoạt động không. Cài đặt phần mềm: Thiết lập các ứng dụng cần thiết như bản đồ, trình nghe nhạc, ứng dụng kết nối điện thoại. Cấu hình kết nối Bluetooth/Wi-Fi: Đảm bảo kết nối điện thoại và các thiết bị khác hoạt động tốt. Cài đặt các tính năng an toàn: Nếu màn hình có camera lùi hoặc cảm biến, cần cấu hình để hiển thị chính xác.',
            },
            {
                stepHead: 'Bước 5: Kiểm tra và hoàn thiện',
                stepDescription:
                    'Kiểm tra các chức năng: Đảm bảo tất cả các chức năng như GPS, âm thanh, video, Bluetooth, camera lùi đều hoạt động bình thường. Kiểm tra các kết nối điện: Đảm bảo không có dây điện lỏng lẻo hoặc vấn đề liên quan đến nguồn. Lắp lại các chi tiết nội thất: Sau khi kiểm tra xong, lắp lại các chi tiết nội thất đã tháo ra ban đầu.',
            },
            {
                stepHead: 'Bước 6: Hướng dẫn sử dụng cho khách hàng',
                stepDescription:
                    'Hướng dẫn khách hàng cách sử dụng các chức năng cơ bản như kết nối Bluetooth, sử dụng GPS, và điều khiển âm thanh/video. Khuyến cáo khách hàng về việc bảo trì và sử dụng màn hình một cách an toàn.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Thay thế màn hình zin bằng màn hình android thông minh có tốt không?',
                description:
                    'Với màn hình zin thông thường trên ô tô chỉ cung cấp các tính năng cơ bản như nghe radio, nghe nhạc qua USB, không có hình ảnh, không kết nối Internet, bluetooth, camera và thường có kích thước nhỏ,… gây một số bất tiện cho chủ xe. Màn hình android cho ô tô được phát triển và bổ sung thêm rất nhiều tiện ích, nâng cao khả năng lái xe an toàn và tăng tính thẩm mỹ cho chiếc xe.',
            },
            {
                id: 2,
                text: 'Cách chọn màn hình android chất lượng',
                description: `Tùy vào mỗi dòng xe cũng như nhu cầu của khách hàng, màn hình andoid ô tô thông minh hiện nay phải đáp ứng được các điều kiện sau:
                    + Kích cỡ màn hình chuẩn, phù hợp với xe.
                    + Độ phân giải màn hình cao như loại Full HD, 2K, 4K,…
                    + Dung lượng, bộ nhớ RAM đủ lớn.
                    + Bộ chip CPU thế hệ mới cho tốc độ lướt mượt, nhanh, không đơ, giật lag,…
                    + Tích hợp định vị, kết nối đa cổng, điều khiển giọng nói, lưu lịch trình, dẫn đường, xem video,…`,
            },
            {
                id: 3,
                text: 'Có nên tự lắp màn hình android tại nhà không?',
                description:
                    'Bạn sẽ rất dễ bắt gặp nhiều video hướng dẫn lắp màn hình tại nhà vô cùng đơn giản. Nhưng thực tế, kỹ thuật này phức tạp hơn bạn nghĩ, người lắp phải có kiến thức chuyên môn về hệ thống điện, đường dây,… trên từng dòng xe ô tô. Nếu thực hiện sai cách, hệ thống điện toàn bộ sẽ gặp vấn đề, gây hỏng mạch, gây cháy,…',
            },
            {
                id: 4,
                text: 'Giá lắp màn hình Android cho ô tô bao nhiêu?',
                description: `Thị trường màn hình Android ô tô hiện nay rất đa dạng các sản phẩm, thương hiệu chất lượng. Tùy thuộc vào từng phân khúc, nhu cầu trải nghiệm của khách hàng, giá độ màn hình DVD Android cho ô tô sẽ khác nhau. Đội ngũ tư vấn của Vietnam Car Care đã khảo sát mức giá chung của Top 5 thương hiệu màn hình DVD Android ô tô mới như sau:
                + Màn hình Android T’EYE: Từ 9.000.000 – 13.000.000 VNĐ
                + Màn hình ICAR: Từ 6.000.000 – 26.000.000 VNĐ
                + Màn hình ZESTECH: Từ 8.000.000 – 25.000.000 VNĐ
                + Màn hình PIONEER: Từ 6.500.000 – 18.000.000 VNĐ
                + Màn hình OLED: Từ 5.000.000 – 14.000.000 VNĐ`,
            },
        ],
    },
    {
        id: 13,
        bannerServices: require('../assets/services/service13.jpg'),
        defaultImage: require('../assets/icons/services13.png'),
        hoverImage: require('../assets/icons/services13_13.png'),
        title: 'Dịch vụ camera hành trình',
        benefit: 'camera hành trình',
        benefitImage: require('../assets/benafit/benafit13.png'),
        benefitContent: [
            {
                benefitHead: 'Bảo vệ người lái',
                benefixDescription:
                    'Trang bị camera hành trình sẽ giúp cho chủ phương tiện có thể chứng minh được quá trình lái xe của mình nếu gặp phải tai nạn giao thông hoặc tranh chấp về vi phạm luật.',
            },
            {
                benefitHead: 'Định vị, chỉ đường chính xác',
                benefixDescription:
                    'Định vị và chỉ đường là hai tính năng quan trọng của camera hành trình ô tô, giúp người lái biết được vị trí hiện tại của mình và cách để đến được địa điểm mong muốn chính xác nhất.',
            },
            {
                benefitHead: 'Tăng cường khả năng lái xe',
                benefixDescription:
                    'Nhờ Camera hành trình, tài xế có thể dễ dàng phân tích tình huống và phản ứng kịp thời với những tình huống nguy hiểm trên đường, giúp tăng cường khả năng quan sát, giám sát an toàn khi lái xe.',
            },
            {
                benefitHead: 'Phát hiện biển báo giao thông',
                benefixDescription:
                    'Với dữ liệu được tích hợp trong hệ thống dẫn đường của camera hành trình, người lái dễ dàng nhận biết được những biển báo giao thông nằm ở vị trí khó nhận biết, thông qua cảnh báo bằng giọng nói.',
            },
            {
                benefitHead: 'Ghi lại sự cố',
                benefixDescription:
                    'Ngoài chỉ đường và cảnh báo giao thông, gắn camera hành trình trên xe ô tô còn giúp người lái ghi lại cảnh vật trên những cung đường đẹp với chuẩn video 2K, 4K, dễ dàng xuất ra những hình ảnh rõ nét.',
            },
        ],
        step: [
            {
                stepHead: 'Bước 1:Tư vấn về camera hành trình ô tô',
                stepDescription:
                    'Kỹ thuật viên thực hiện khảo sát nhu cầu của khách hàng và tư vấn các loại camera hành trình xe ô tô phù hợp.',
            },
            {
                stepHead: 'Bước 2: Quyết định vị trí của camera hành trình',
                stepDescription:
                    'Kỹ thuật viên ngồi ở ghế lái và thử các vị trí khác nhau cho camera hành trình, đặt camera trong tầm tay với chỗ ngồi nhưng không gây cản trở tầm nhìn hoặc sẽ dựa trên yêu cầu thực tế của khách hàng.',
            },
            {
                stepHead: 'Bước 3: Lắp đặt camera hành trình chi tiết',
                stepDescription:
                    'Kỹ thuật viên xác định vị trí hộp cầu chì và bắt đầu các công đoạn kiểm tra mạch điện, đấu nối các dây, hệ thống tiếp đất,… đảm bảo camera hành trình hoạt động tốt',
            },
            {
                stepHead: 'Bước 4: Kiểm tra lại các cài đặt',
                stepDescription:
                    'Sau khi lắp đặt và kết nối điện, nhân viên sẽ khởi động xe để kiểm tra lại camera hành trình. Đảm bảo rằng chúng hoạt động đúng cách.',
            },
            {
                stepHead: 'Bước 5: Hướng dẫn sử dụng và bàn giao',
                stepDescription:
                    'Cuối cùng, nhân viên Vietnam Car Care sẽ hướng dẫn cách sử dụng camera hành trình ô tô và các tính năng sau khi lắp đặt.',
            },
        ],
        question: [
            {
                id: 1,
                text: 'Lắp Camera hành trình ô tô có bắt buộc hay không?',
                description:
                    'Camera hành trình là trang bị đáng giá giúp bạn ghi lại toàn bộ quá trình khi di chuyển trên đường và là bằng chứng chứng minh khi xảy ra sự cố. Tại Việt Nam, việc lắp camera hành trình gần như là bắt buộc đối với các phương tiện kinh doanh vận tải, hành khách, xe container,… Nếu không lắp đầy đủ camera hành trình ô tô, chủ sở hữu phương tiện sẽ bị xử phạt theo quy định pháp luật.',
            },
            {
                id: 2,
                text: 'Có nên gắn Camera hành trình cho phía sau xe?',
                description:
                    'Không nhất thiết phải gắn camera hành trình sau xe. Nếu ngân sách đáp ứng đủ, bạn có thể cân nhắc việc lắp đặt một camera hành trình phía sau để đảm bảo an toàn khi tham gia giao thông. Camera phía sau sẽ có thể ghi lại mọi va chạm hoặc bất kỳ sự cố nào xảy ra ở phía sau xe của bạn. Hiện tại, luật chưa quy định bắt buộc gắn camera hành trình ô tô phía sau.',
            },
            {
                id: 3,
                text: 'Phân biệt Camera hành trình và Camera 360 độ ô tô',
                description:
                    'Camera 360 độ ô tô có chức năng chính trong việc xóa điểm mù, hỗ trợ quan sát khi lái xe, cho góc quay toàn cảnh bằng những hình ảnh giả lập 2D hoặc 3D và hiển thị lên màn hình điều khiển trong ô tô, không có tính năng thu âm.Trong khi đó, Camera hành trình có chức năng ghi lại hành trình di chuyển, lưu trữ video lẫn âm thanh thông qua các ống kính, có hỗ trợ thẻ nhớ và giá thành thấp hơn camera 360. Điều này giúp bạn có thể tránh khỏi những rắc rối khi va chạm hoặc những kỉ niệm đẹp khi phượt cùng gia đình.',
            },
            {
                id: 4,
                text: 'Camera hành trình ô tô nào tốt nhất?',
                description: `Hiện nay có rất nhiều thương hiệu camera hành trình chất lượng tại Việt Nam. Theo khảo sát các khách hàng thực hiện dịch vụ chăm sóc xe tại L&K Tech, chúng tôi nhận thấy 4 loại camera hành trình phổ biến nhất trên xe như sau: - Camera hành trình ô tô Vietmap
                - Camera hành trình Webvision
                - Camera hành trình ô tô Xiaomi
                - Camera hành trình HP`,
            },
        ],
    },
];

export const blogData = [
    {
        id: 1,
        image: require('../assets/sidebar/blog1.jpg'),
        author: 'Admin',
        date: '01/09/2024',
        comments: '3 comments',
        content:
            '"Bạn có biết rằng chỉ cần một vài mẹo nhỏ, chiếc xe yêu quý của bạn sẽ luôn sáng bóng như mới? Không chỉ vậy, việc chăm sóc xe đúng cách còn giúp kéo dài tuổi thọ và tăng giá trị của xe. Hãy cùng khám phá những bí quyết chăm sóc xe đơn giản nhưng hiệu quả ngay tại nhà!"',
    },
    {
        id: 2,
        image: require('../assets/sidebar/blog2.jpg'),
        author: 'User123',
        date: '02/09/2024',
        comments: '5 comments',
        content:
            'Bạn đã bao giờ nghe nói đến việc phủ ceramic cho xe chưa? Công nghệ này không chỉ giúp bảo vệ lớp sơn xe khỏi các tác động từ môi trường mà còn mang đến độ bóng loáng vượt trội. Hãy cùng tìm hiểu xem phủ ceramic có gì đặc biệt và tại sao nó lại trở thành xu hướng được nhiều người ưa chuộng',
    },
    {
        id: 3,
        image: require('../assets/sidebar/blog3.jpg'),
        author: 'Guest',
        date: '03/09/2024',
        comments: '10 comments',
        content:
            'Hồi trước, tôi từng rất lo lắng về những vết xước nhỏ trên chiếc xe mới tậu. Nhưng sau khi tìm hiểu và áp dụng một số mẹo nhỏ, chiếc xe của tôi lại trở nên bóng loáng như mới. Nếu bạn cũng đang gặp phải tình trạng tương tự, hãy đọc ngay bài viết này để tìm ra giải pháp nhé!',
    },
];
